module.exports = __webpack_public_path__ + "img/icon-circle-exclamation.7527e0c8.svg";